export default __webpack_public_path__ + "static/media/icon-unlock.32343971.svg";